//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TheMenu",
  data() {
    return {
      userType: this.$localStore.get("userType"),
    };
  },
  computed: {
    authenticated() {
      return this.$localStore.get("authenticated");
    },
  },
};
